import { isPlatformBrowser } from '@angular/common';
import { Inject, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'tagTextUnescape'
})
export class TagTextUnescapePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: string) { }

  transform(value: any, args?: any): any {
    if (isPlatformBrowser(this.platformId)) {
      const doc = new DOMParser().parseFromString(value, 'text/html');
      const unescaped = doc.body.childElementCount === 0 ? doc.documentElement.textContent : value;
      return this.sanitizer.bypassSecurityTrustHtml(unescaped);
    } else {
      return value;
    }
  }

}
